import React, { Component } from "react";
import ReactDOM from "react-dom";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";

import Header from "./components/header/header";
import Footer from "./components/footer/footer";
import Home from "./screens/home/home";
import CompetenceResult from "./screens/competenceResult/competenceResult";
import Enem from "./screens/enem/enem";
import BlockedUser from "./screens/blockedUser/blockedUser";
import UploadCompetence from './screens/uploadCompetence/uploadCompetence';
import InfoUser from "./screens/infoUser/infoUser";
import RegisterRequest from "./screens/registerRequest/registerRequest";
import TopBar from "./components/topBar/topBar";
import LoginRedirect from "./screens/login/LoginRedirect";
import LogoutRedirect from "./screens/login/LogoutRedirect";
import RouterGuard from './components/routerGuard/routerGuard';
import Auth from "./services/AuthService";
import decode from "jwt-decode";

import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./index.css";


class AppRouter extends Component {

  ignore = {
    '/login-redirect': true,
  }

  logout = {
    '/logout-redirect': true
  }

  constructor(props) {
    super(props);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.onRouteChanged = this.onRouteChanged.bind(this);
    this.login = this.login.bind(this);
    this.state = {
      userData: null
    };
  }

  async componentDidMount() {
    return await this.login();
  }

  async onRouteChanged() {
    return await this.login();
  }

  async login() {
    if (this.ignore[window.location.pathname]) {
      return;
    }

    if (Auth.isAuthenticated()) {
      const userData = await decode(Auth.getData().data.id_token);
      this.setState({
        userData: userData.given_name
      });
    }
  }

  render () {
    return (
      <Router>
          <TopBar username={this.state.userData}></TopBar>
          <Header username={this.state.userData} component={Header}/>
            <Switch>
              <Route exact path="/" component={Home} />
              <Route path="/home" component={Home} />
              <RouterGuard path="/linguagens" component={(props) => <CompetenceResult {...props} sigla="LIT" title="Linguagens e suas tecnologias" icon="iconlit" color="blue" columnist={true} competence={["10151", "10081", "10131"]} />} />
              <RouterGuard path="/matematica" component={(props) => <CompetenceResult {...props} sigla="MTT" title="Matemática e suas tecnologias" icon="iconMtt" color="purple" columnist={false} competence={["10151", "10116", "10096"]} />} />
              <RouterGuard path="/ciencias" component={(props) => <CompetenceResult {...props} sigla="CNT" title="Ciência da Natureza e suas tecnologias" icon="iconCnt" color="green" columnist={false} competence={["10116", "10106", "10141"]} />} />
              <RouterGuard path="/ciencias-humanas-e-sociais" component={(props) => <CompetenceResult {...props} sigla="CHSA" title="Ciências Humanas e Sociais Aplicadas" columnist={true} icon="iconChsa" color="orange" competence={["10116", "10096", "10131", "10141", "10111", "53051", "10131"]} />} />
              <RouterGuard path="/formacao-tecnica-profissional" component={(props) => <CompetenceResult {...props} sigla="FTP" title="Formação Técnica e Profissional" columnist={false} icon="iconFtp" color="brown" competence={["10151", "10081", "10131"]} />} />
              <RouterGuard path="/enem" component={Enem}/>
              <RouterGuard path="/upload-competence" adminRoute={true} component={UploadCompetence} />   
              <RouterGuard path="/infoUser" component={InfoUser} />          
              <Route path="/blocked" component={BlockedUser} />     
              <Route path="/pedido-registro" component={RegisterRequest} /> 
              <Route exact path="/login-redirect" component={LoginRedirect} />   
              <Route exact path="/logout-redirect" component={LogoutRedirect} />                           
              <Route component={Home} />
            </Switch>
          <Footer component={Footer} />
      </Router>
    );
  }

}

export default AppRouter;
ReactDOM.render(<AppRouter/>, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister();
